import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      width: 496,

      [mediaQuery(breakpoints.laptop)]: {
        marginInline: 'auto',
        maxWidth: '100%',
      },
    },
    textTitle: {
      fontWeight: 600,
      marginBottom: 8,
    },
    titleLink: {
      color: 'var(--x-black)',
      textDecoration: 'underline',
    },
    textDescription: {},
    textContainer: {
      display: 'flex',
      gap: 24,
    },
    itemContainer: {
      marginBottom: 24,
    },
  }),
  {
    name: 'TextColumns',
  },
);

export default useStyles;
